module.exports = __webpack_public_path__ + "static/img/product07.b4552552.jpg";